"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "rezzoaglio": {
    "68b869a1": [{
      "hkey": "d180e47b",
      "slug": "cerisola-magnasco-villanoce",
      "name": "Cerisola-Magnasco-Villanoce",
      "primary": true,
      "skipSearch": false
    }],
    "cerisola": [{
      "hkey": "d180e47b",
      "slug": "cerisola-magnasco-villanoce",
      "name": "Cerisola-Magnasco-Villanoce",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "3f377a08": [{
      "hkey": "d180e47b",
      "slug": "cerisola-magnasco-villanoce",
      "name": "Cerisola-Magnasco-Villanoce",
      "primary": true,
      "skipSearch": false
    }],
    "magnasco": [{
      "hkey": "d180e47b",
      "slug": "cerisola-magnasco-villanoce",
      "name": "Cerisola-Magnasco-Villanoce",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "rezzoaglio"
    }],
    "80ad168c": [{
      "hkey": "721d42b0",
      "slug": "priosa-groparolo",
      "name": "Priosa-Groparolo",
      "primary": true,
      "skipSearch": false
    }],
    "priosa": [{
      "hkey": "721d42b0",
      "slug": "priosa-groparolo",
      "name": "Priosa-Groparolo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "fba9995f": [{
      "hkey": "8004ed70",
      "slug": "vicosoprano",
      "name": "Vicosoprano",
      "primary": true,
      "skipSearch": false
    }],
    "vico-soprano": [{
      "hkey": "8004ed70",
      "slug": "vicosoprano",
      "name": "Vicosoprano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "7c8489cd": [{
      "hkey": "d180e47b",
      "slug": "cerisola-magnasco-villanoce",
      "name": "Cerisola-Magnasco-Villanoce",
      "primary": true,
      "skipSearch": false
    }],
    "villanoce": [{
      "hkey": "d180e47b",
      "slug": "cerisola-magnasco-villanoce",
      "name": "Cerisola-Magnasco-Villanoce",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "rezzoaglio"
    }]
  }
};
exports["default"] = _default;